import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3>🎳 <span>SkyLanes</span> Bowling</h3>
            <p>
              Located in the beautiful Poconos, SkyLanes Bowling Center is your premier
              destination for bowling, entertainment, and fun. Visit us for an unforgettable experience.
            </p>
            <div className="social-links">
              <a href="https://facebook.com" className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Facebook">f</a>
            </div>
          </div>
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="tel:+15704217680">Call Us Now</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li><a href="#hours">Open Bowling</a></li>
              <li><a href="#home">Rock & Roll Nights</a></li>
              <li><a href="#hours">League Bowling</a></li>
              <li><Link to="/parties-events">Birthday Parties</Link></li>
              <li><Link to="/parties-events">Corporate Events</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><a href="tel:+15704217680">📞 +1 570-421-7680</a></li>
              <li><a href="mailto:contactskylanes@gmail.com">✉ contactskylanes@gmail.com</a></li>
              <li><a href="https://maps.google.com/?q=208+Skyline+Dr,+East+Stroudsburg,+PA+18301" target="_blank" rel="noopener noreferrer">📍 208 Skyline Dr, East Stroudsburg, PA 18301, United States</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} SkyLanes Bowling Center. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
